import { popover } from "@kirvanobr/theme";

import { TriggerIcon } from "./tooltip-trigger-icon";

const TooltipTrigger = (
  <button className={popover().tooltipTrigger()} type="button">
    <TriggerIcon />
  </button>
);

export default TooltipTrigger;
